const cacheHash = window.getClientConfiguration("", ["book", "imagecachehash"]);
const queryHash = cacheHash ? "?cachehash=" + cacheHash : "";

function getThumbnailPrefix() {
  return "thumbs/";
}

function getImagePrefix(scale) {
  let prefix = "imgsvg/ps_";

  if (scale > 1) {
    prefix = "imgsvg/pl_";
  } else if (scale > 0.5) {
    prefix = "imgsvg/p_";
  }

  return prefix;
}

// thumbnails start by 0
export function getThumbnailPath(page) {
  return `${getThumbnailPrefix()}${page - 1}.jpg${queryHash}`;
}

// cache hash for images necessary
export function getImagePath(page, scale) {
  return `${getImagePrefix(scale)}${page}.jpg${queryHash}`;
}
